'use strict';

import { DoubleSide, MeshStandardMaterial } from 'three';

const fluffy_vertex_vars = `
uniform float intensity;
uniform bool uNormalize;
uniform float inflate;
uniform float windSpeed;
uniform float uTime;
uniform bool flip;
varying vec3 fluffyNormal;
`;

const fluffy_vertex_func = `
float inverseLerp(float v, float minValue, float maxValue) {
    return (v - minValue) / (maxValue - minValue);
}

float remap(float v, float prevMin, float prevMax, float newMin, float newMax) {
    float t = inverseLerp(v, prevMin, prevMax);
    return mix(newMin, newMax, t);
}

float getScalar(mat4 matrix) {
    float scaleX = length(vec3(matrix[0]));
    float scaleY = length(vec3(matrix[1]));
    float scaleZ = length(vec3(matrix[2]));
return length(vec3(scaleX,scaleY,scaleZ)) / 1.7320508075688772;
}

mat4 rotateZ(float radians) {
  float c = cos(radians);
  float s = sin(radians);

return mat4(
    c, -s, 0, 0,
    s, c, 0, 0,
    0, 0, 1, 0,
    0, 0, 0, 1
  );
}

vec4 applyWind(vec4 v) {
  float boundedYNormal = remap(normal.y, -1.0, 1.0, 0.0, 1.0);
  float posXZ = position.x + position.z;
  float power = windSpeed / 5.0 * -0.5;

  float topFacing = remap(sin(uTime + posXZ), -1.0, 1.0, 0.0, power);
  float bottomFacing = remap(cos(uTime + posXZ), -1.0, 1.0, 0.0, 0.05);
  float radians = mix(bottomFacing, topFacing, boundedYNormal);

  return rotateZ(radians) * v;
}
`;

const fluffy_vertex_projectVertex = `
vec4 mvPosition = vec4( transformed, 1.0 );
float mScale = getScalar(modelMatrix);

#ifdef USE_BATCHING
    mScale = getScalar(batchingMatrix);
	mvPosition = batchingMatrix * mvPosition;

#endif

#ifdef USE_INSTANCING

    mScale = getScalar(instanceMatrix);
	mvPosition = instanceMatrix * mvPosition;

#endif

    vec2 vertexOffset = vec2(
        remap(uv.x, 0.0, 1.0, -1.0, 1.0),
        remap(uv.y, 0.0, 1.0, -1.0, 1.0)
    );
    
    if (flip) {
        vertexOffset *= vec2(-1.0, 1.0);
    }

    if (uNormalize) {
      vertexOffset = normalize(vertexOffset);
    }
 
    vec3 fluffyTransformPosition = vec3(vertexOffset, 1.0) * mScale;
    vec3 fluffyTransformNormal = fluffyNormal * mScale;
    vec4 windPosition = applyWind(vec4(fluffyTransformPosition,1.0));
    
    mvPosition = modelViewMatrix * mvPosition;
    mvPosition += vec4(mix(vec3(0.0), windPosition.xyz + fluffyTransformNormal, intensity), 0.0);
    gl_Position = projectionMatrix * mvPosition;
`;

export class FluffyMaterial extends MeshStandardMaterial{
	#shader;
	
	constructor (parameters) {
		super(parameters);
		
		this.side = DoubleSide;
		this.intensity = 1;
		this.inflate = 0;
		this.windSpeed = 0;
		this.flip = false;
		this.normalize = true;
		this.defines.FLUFFY_MATERIAL = '';
		this.customPrograms = [this.upgradeShader.bind(this)];
	}
	
	upgradeShader(shader) {
		shader.uniforms.intensity = {value: this.intensity};
		shader.uniforms.uNormalize = {value: this.normalize};
		shader.uniforms.inflate = {value: this.inflate};
		shader.uniforms.flip = {value: this.flip};
		shader.uniforms.windSpeed = {value: this.windSpeed};
		shader.uniforms.uTime = {value: 0};
		
		shader.vertexShader = fluffy_vertex_vars + shader.vertexShader;
		shader.vertexShader = shader.vertexShader.replace('#include <clipping_planes_pars_vertex>',[
			'#include <clipping_planes_pars_vertex>',
			fluffy_vertex_func
		].join('\n'));
		
		shader.vertexShader = shader.vertexShader.replace('#include <defaultnormal_vertex>',[
			'#include <defaultnormal_vertex>',
			'fluffyNormal = transformedNormal * inflate;'
		].join('\n'));
		
		shader.vertexShader = shader.vertexShader.replace('#include <project_vertex>',fluffy_vertex_projectVertex);
		this.#shader = shader;
	}
	
	tick(delta) {
		if (this.#shader) {
			this.#shader.uniforms.uTime.value += delta * this.windSpeed;
		}
	}
	
}
